import CREATE_TAG from './createVipTag.graphql'
import UPDATE_TAG from './updateVipTag.graphql'
import DELETE_TAG from './deleteVipTag.graphql'

export {CREATE_TAG, UPDATE_TAG, DELETE_TAG}



// WEBPACK FOOTER //
// ./src/modules/common/graphql/tags/index.ts